class TestInstructionUserInputModalController {
    constructor(TraceDetailsServiceApi, UtpSummaryServiceApi) {
        this.showStopButton = false;
        this.showInstructionMessage = false;
        this.$onInit = () => {
            this.showLoadingSpinner = true;
            this.instructionTraceTreeVM = this.resolve.instructionTraceTreeVM;
            this.reportParametersFields = [];
            this.reportParametersModel = [];
            // get the xml content associated to the trace of type Instruction
            this.UtpSummaryServiceApi.getTraceXmlContent(this.instructionTraceTreeVM.Id, false).then((response) => {
                let xml = response.data;
                // get the instruction parameters from the xml
                this.instructionParameters = this.getInstructionParameters(xml);
                // check if the stop button should be shown to the user
                let canAbortParam = this.getParameter(this.instructionParameters, 'CanAbortTest');
                if (!_.isNull(canAbortParam))
                    this.showStopButton = true;
                // check if there's an instruction message to display to the user
                let instructionParam = this.getParameter(this.instructionParameters, 'instruction');
                if (!_.isNull(instructionParam)) {
                    this.instructionMessage = instructionParam.DisplayName;
                    this.showInstructionMessage = true;
                }
                // create the form content
                this.buildFormlyFieldDefinition(this.getFormParameters(this.instructionParameters));
                this.showLoadingSpinner = false;
            });
        };
        this.getFormParameters = (params) => {
            return params.filter(i => i.Name.toLowerCase() !== 'canaborttest' && i.Name.toLowerCase() !== 'instruction');
        };
        this.getParameter = (params, name) => {
            let filteredItems = params.filter(i => i.Name.toLowerCase() === name.toLowerCase());
            if (filteredItems.length > 0)
                return filteredItems[0];
            else
                return null;
        };
        this.buildFormlyFieldDefinition = (params) => {
            // Clear out existing model definition
            this.reportParametersFields = [];
            let result = _.groupBy(params, 'Type');
            for (let type in result) {
                let row;
                if (type.toUpperCase() === 'BOOL') {
                    // If it's a bool put them all in the same row so they don't take so much space
                    row = {
                        className: 'row',
                        fieldGroup: []
                    };
                    for (let param of result[type]) {
                        row.fieldGroup.push(this.buildFormlyField(param));
                    }
                    this.reportParametersFields.push(row);
                }
                else {
                    // Anything else (e.g string) just give it it's own row as it will be an input box, textarea, datetime picker e.t.c
                    for (let param of result[type]) {
                        row = {
                            className: 'row',
                            fieldGroup: []
                        };
                        row.fieldGroup.push(this.buildFormlyField(param));
                        this.reportParametersFields.push(row);
                    }
                }
            }
        };
        this.buildFormlyField = (instructionParam) => {
            let defaultValue = '';
            let htmlType = 'input';
            let pattern = '';
            let fieldClassName = 'col-xs-12';
            let options;
            switch (instructionParam.Type.toUpperCase()) {
                case 'BOOL':
                    htmlType = 'checkbox';
                    defaultValue = false;
                    fieldClassName = 'col-xs-6';
                    break;
                case 'SELECT':
                    htmlType = 'select';
                    if (instructionParam.Value) {
                        options = this.getSelectOptions(instructionParam.Value.split(','));
                    }
                    break;
            }
            switch (instructionParam.DisplayName.toUpperCase()) {
                case 'FEEDBACK':
                    htmlType = 'textarea';
                    break;
            }
            let fieldGroup = {
                key: instructionParam.Name,
                type: htmlType,
                className: fieldClassName,
                defaultValue: defaultValue,
                templateOptions: {
                    notNull: htmlType === 'select',
                    label: instructionParam.DisplayName,
                    placeholder: '',
                    options: options,
                    required: !instructionParam.Optional,
                    pattern: pattern
                }
            };
            return fieldGroup;
        };
        this.getSelectOptions = (options) => {
            let list = [];
            let item;
            let i;
            for (i = 0; i < options.length; i++) {
                item = {
                    name: options[i],
                    value: options[i]
                };
                list.push(item);
            }
            return list;
        };
        this.getInstructionParameters = (xml) => {
            let params = [];
            let param;
            let xmlDoc = $.parseXML(xml);
            let paramNode;
            let paramNodes = xmlDoc.getElementsByTagName('Parameter');
            let i;
            for (i = 0; i < paramNodes.length; i++) {
                paramNode = paramNodes[i];
                param = {
                    DisplayName: paramNode.getAttribute('displayName'),
                    Editable: paramNode.getAttribute('editable') === 'true',
                    Name: paramNode.getAttribute('name'),
                    Type: paramNode.getAttribute('type'),
                    Value: paramNode.getAttribute('value'),
                    Optional: paramNode.getAttribute('optional') === 'true' || paramNode.getAttribute('optional') === 'True'
                };
                params.push(param);
            }
            return params;
        };
        this.continueExecution = () => {
            let result = [];
            let instructionParam = this.getParameter(this.instructionParameters, 'instruction');
            if (!_.isNull(instructionParam)) {
                result.push({
                    Name: instructionParam.Name,
                    Value: instructionParam.DisplayName
                });
            }
            for (let key in this.reportParametersModel) {
                let paramValue = this.reportParametersModel[key].toString();
                result.push({
                    Name: key,
                    Value: paramValue
                });
            }
            this.close({ $value: result });
        };
        this.stopExecution = () => {
            this.dismiss();
        };
        this.cancel = (closeDialog) => {
            if (closeDialog) {
                this.close();
            }
            else {
                this.dismiss();
            }
        };
        this.TraceDetailsServiceApi = TraceDetailsServiceApi;
        this.UtpSummaryServiceApi = UtpSummaryServiceApi;
    }
}
angular.module('app').component('testInstructionUserInput', {
    bindings: {
        resolve: '<', // ITestInstructionUserInputModalResolve
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/TraceDetails/TestInstructionUserInput/test-instruction-user-input-modal.tpl.html',
    controllerAs: 'vm',
    controller: TestInstructionUserInputModalController
});
